export default class Popup {
  constructor(el) {
    if (el.dataset.initialized || typeof el.showModal !== 'function') return
    el.dataset.initialized = 'true'
    this.el = el
    this.key = `garance-popup:${el.dataset.campaign || 'default'}`
    this.days = Math.max(0, Number(el.dataset.days) || 0)
    this.dismissed = false
    this.wasRunning = false
    el.querySelector('.garance-popup__close').addEventListener('click', () => el.close())
    el.addEventListener('click', event => {
      const rect = el.getBoundingClientRect()
      if (event.target === el && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) el.close()
    })
    el.addEventListener('close', () => this.onClose())
    el.querySelector('.garance-popup__actions .btn')?.addEventListener('click', () => el.close())
    // Native dialog handles Escape, focus containment and background inertness.
    this.timer = window.setTimeout(() => this.open(), Math.max(0, Number(el.dataset.delay) || 0) * 1000)
    window.addEventListener('pagehide', () => { if (el.open) el.close() })
  }

  eligible() {
    const now = Date.now()
    const start = Number(this.el.dataset.start) || 0
    const end = Number(this.el.dataset.end) || 0
    if ((start && now < start) || (end && now >= end) || this.dismissed) return false
    try {
      if (sessionStorage.getItem(this.key)) return false
      if (Number(localStorage.getItem(this.key)) > now) return false
    } catch (_) { /* Storage unavailable: popup still works. */ }
    return true
  }

  open() {
    if (!this.eligible()) return
    // Avoid stacking over a reservation panel or another modal.
    if (document.querySelector('dialog[open], [aria-modal="true"]:not(.garance-popup)')) {
      this.timer = window.setTimeout(() => this.open(), 1000)
      return
    }
    this.previousFocus = document.activeElement
    this.previousOverflow = document.documentElement.style.overflow
    this.wasRunning = Boolean(window.lenis && !window.lenis.isStopped)
    if (this.wasRunning) window.lenis.stop()
    document.documentElement.style.overflow = 'hidden'
    this.el.showModal()
  }

  onClose() {
    this.dismissed = true
    try {
      if (this.days > 0) localStorage.setItem(this.key, String(Date.now() + this.days * 86400000))
      else sessionStorage.setItem(this.key, '1')
    } catch (_) { /* Ignore denied storage access. */ }
    document.documentElement.style.overflow = this.previousOverflow || ''
    if (this.wasRunning) window.lenis?.start()
    if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true })
  }
}
